import { render, staticRenderFns } from "./SupportRequestButton.vue?vue&type=template&id=4de3edc6&"
import script from "./SupportRequestButton.vue?vue&type=script&lang=js&"
export * from "./SupportRequestButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports